import Styled from 'styled-components';

const Card = Styled.section`
  width: 100%;
  padding: 24px;
  background: #FFFFFF;
  border-radius: 14px;
`;

const Title = Styled.h2`
  margin: 0;
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  color: #231F20;
`;

const Description = Styled.p`
  margin: 4px 0 0;
  font-size: 14px;
  line-height: 19px;
  color: #8C8C8C;
`;

const Row = Styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 20px;
`;

const Fields = Styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
`;

const PeriodLabel = Styled.label`
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #231F20;
`;

const Separator = Styled.span`
  font-size: 14px;
  line-height: 19px;
  color: #8C8C8C;
`;

const DateInput = Styled.input`
  height: 42px;
  padding: 0 12px;
  border: 1px solid #DBDBDB;
  border-radius: 7px;
  background: #FFFFFF;
  font-size: 14px;
  color: #231F20;
  outline: none;
  transition: border-color 0.2s ease-in-out;

  &:focus {
    border-color: ${({ theme }) => theme.color.primary};
  }
`;

const Columns = Styled.p`
  margin: 16px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: #8C8C8C;
`;

export {
  Card,
  Title,
  Description,
  Row,
  Fields,
  PeriodLabel,
  Separator,
  DateInput,
  Columns,
};
